import React from 'react';
import { Badge } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ConstantAction from '../../actions/ConstantAction';
import { DASH_GLOBE } from '../../config/media';

const sideBarValues = [
    {
        key: 'hosting',
        name: 'Hosting',
        path: '/hosting'
    },
    {
        key: 'general',
        name: 'General',
        path: '/general'
    },
    {
        key: 'financial',
        name: 'Assets',
        path: '/financial'
    },
    {
        key: 'trading',
        name: 'Markets',
        path: '/trade'
    },
    // {
    //     key: 'users',
    //     name: 'Users',
    //     path: '/users'
    // },
    // {
    //     key: 'members',
    //     name: 'Members',
    //     path: '/members'
    // },
    // {
    //     key: 'tier',
    //     name: 'Tiers',
    //     path: '/tier'
    // },
    // {
    //     key: 'plugins',
    //     name: 'Plugins',
    //     path: '/plugin'
    // },
    // {
    //     key: 'apikeys',
    //     name: 'Exchange keys',
    //     path: '/apikey'
    // },
    {
        key: 'customize',
        name: 'Customize',
        path: '/customize'
    },
    {
        key: 'VerifyAgree',
        name: 'Verification',
        path: '/verifyAgree'
    },
    // {
    //     key: 'kyc',
    //     name: 'KYC',
    //     path: '/kyc'
    // },
    {
        key: 'billing',
        name: 'Billing',
        path: '/billing'
    },
    // {
    //     key: 'collateral',
    //     name: 'Collateral',
    //     path: '/collateral'
    // }
];

const SideBarMain = ({ data = [], pathName = '', biz, requestApplyChangesModal }) => {
    // const mobileToggle = false;
    // const btnStyle = {
    //     width: '156px'
    // };

    // const goToCollateral = () => {
    //     if (data.length === 0) {
    //         history.push('/');
    //     } else {
    //         history.push('/collateral');
    //     }
    // };
    let ExchangeName = '';
    // let imgIndex = 1;
    if (data.length && data[0].display_name) {
        ExchangeName = data[0].display_name;
        // imgIndex = (data[0].id % 6) + 1;
    }
    if (biz.EXCHANGE_NAME) {
        ExchangeName = biz.EXCHANGE_NAME;
    }
    if (!data.length) {
        return null;
    }
    // const handleApply = () => {
    //     requestApplyChangesModal({ isOpenApplyModal: true });
    // };
    let isCoinConfig = !!(data[0].coins.filter(coin => !coin.id).length);
    return (
        <div>
            <div>
                <Link key="dashboard" to="/dashboard">
                    <div
                        className={
                            pathName.includes('/dashboard')
                                ? "sidebar-menu-dash flex-menu active-exchange-menu"
                                : "sidebar-menu-dash flex-menu"
                        }
                    >
                        <div className="flex-menu">
                            <img
                                src={DASH_GLOBE}
                                alt="Exchange logo"
                                className="exchange-logo"
                            />
                        </div>
                        <div>
                            <div>DASHBOARD</div>
                            <div
                                className={
                                    ExchangeName
                                        ? "exchange-name"
                                        : "exchange-no-name"
                                }
                            >
                                {ExchangeName}
                            </div>
                        </div>
                    </div>
                </Link>
                {sideBarValues.map((menu) => {
                    return (
                        <Link key={menu.key} to={menu.path}>
                            <div
                                className={
                                    pathName.includes(menu.path)
                                        ? "sidebar-menu active-menu"
                                        : "sidebar-menu"
                                }
                            >
                                {(menu.name === 'Assets' && isCoinConfig)
                                    || (menu.name === 'Billing' && data[0] && !data[0].is_paid)
                                    || (menu.name === 'Hosting' && data[0] && !data[0].domain && !data[0].url)
                                    || (menu.name === 'Verification' && data[0] && data[0].is_signed === false)
                                    ? <Badge count={1} offset={[8, 0]}>
                                        <span>{menu.name}</span>
                                    </Badge>
                                    : menu.name
                                }
                            </div>
                        </Link>
                    );
                })}
            </div>
            {/*<div className="apply-wrapper">
                <Button type="primary" className="apply-btn" onClick={handleApply}>
                    <img src={APPLY_REFRESH_ICON} className="nav-icon" alt="apply latest" />
                    Apply latest changes
                </Button>
            </div>*/}
        </div>
    );
}

const mapStateToProps = (state) => ({
    data: state.exchange,
    biz: state.setup.biz
});

const mapDispatchToProps = (dispatch) => ({
    requestApplyChangesModal: bindActionCreators(ConstantAction.requestApplyChangesModal, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SideBarMain);
